/* eslint-disable prefer-template,max-len,no-nested-ternary */
import React from 'react';
import { connect } from 'react-redux';
import { Modal, ButtonToolbar, Button, ModalHeader } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { currentTimezoneAggr } from '../../../../../shared/helpers/Dates';
import Hook from '../../../../../shared/hooks';
import {
  setShowBrandStatusHistoryModal,
  setCurrentMediaContent,
} from '../../../../../redux/reducers/brand/CreatorsReducer';

const BrandStatusHistoryModal = ({
  isOpen,
  record,
  dispatch,
}) => {
  const { records, loading, error } = Hook.useEntityHistoryHook({
    url: '/api/brand/content/get-entity-history',
    entity: 'MediaContent',
    id: record?.params?._id || record?.id,
    field: 'brandStatus',
    isOpen,
    // These modals rendered the embedded array in insertion order.
    oldestFirst: true,
  });

  const close = () => {
    dispatch(setShowBrandStatusHistoryModal(false));
    dispatch(setCurrentMediaContent({}));
  };

  return (
    <Modal isOpen={isOpen} toggle={close}>
      <ModalHeader
        toggle={close}
        tag="h3"
        className="modal-title-statistics"
      >
        Status Change History
      </ModalHeader>
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {loading ? <div className="mt-3 mb-3 pl-3">Loading...</div> : null}
        {error ? <div className="mt-3 mb-3 pl-3 text-danger">{error}</div> : null}
        {!loading && !error && records.length === 0 ? (
          <div className="mt-3 mb-3 pl-3 text-muted">No status changes recorded.</div>
        ) : null}
        {records.length > 0 ? (
          <div className="mt-1 mb-4">
            {records.map(item => (
              <div key={item._id}>
                <div><strong>{moment(item.changedAt).format('M/D/YYYY h:mm A')} {currentTimezoneAggr()}</strong></div>
                <div className="pl-3">
                  {item.changedBy || 'AUTOMATION'} - <b>{item.oldValue}</b> changed to <b>{item.newValue}</b>
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
      <ButtonToolbar className="modal__footer">
        <Button className="modal_cancel btn-sm" color="secondary" onClick={close}>Close</Button>
      </ButtonToolbar>
    </Modal>
  );
};

BrandStatusHistoryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  record: PropTypes.objectOf(PropTypes.any).isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  record: state.creators.currentMediaContent,
  isOpen: state.creators.showBrandStatusHistoryModal,
});

export default connect(mapStateToProps)(BrandStatusHistoryModal);
